<template>
  <div class="form_container">
    <h1 v-if="modalTitle === 'Add Contractor'">{{$t('addEditModalVue.modalAddTitle')}}</h1>
    <h1 v-else>{{$t('addEditModalVue.modalEditTitle')}}</h1>
    <div class="wrapper">
      <form @submit.prevent="addEmployee">
        <modal_input
          v-model="contractor.firstName"
          type="text"
          :label="$t('addEditModalVue.firstNameLabel')"
        ></modal_input>
        <modal_input
          v-model="contractor.lastName"
          type="text"
          :label="$t('addEditModalVue.lastNameLabel')"
        ></modal_input>
        <modal_input
          v-model="contractor.companyName"
          type="text"
          :label="$t('addEditModalVue.companyNameLabel')"
        ></modal_input>
        <modal_input
          v-model="contractor.email"
          value="email"
          type="email"
          :label="$t('addEditModalVue.emailLabel')"
        ></modal_input>
        <modal_input
          v-model="contractor.phone"
          value="phone"
          type="tel"
          :label="$t('addEditModalVue.phoneLabel')"
        ></modal_input>
        <modal_input
          v-model="contractor.street"
          value="street"
          type="text"
          :label="$t('addEditModalVue.streetLabel')"
        ></modal_input>
        <modal_input
          v-model="contractor.postalCode"
          value="postalCode"
          type="text"
          :label="$t('addEditModalVue.postalCodeLabel')"
        ></modal_input>
        <modal_input
          v-model="contractor.city"
          value="city"
          type="text"
          :label="$t('addEditModalVue.cityLabel')"
        ></modal_input>
        <modal_input
          v-model="contractor.country"
          value="country"
          type="text"
          :label="$t('addEditModalVue.countryLabel')"
        ></modal_input>
        <modal_input
          v-model="contractor.businessID"
          value="businessID"
          type="text"
          :label="$t('addEditModalVue.businessIDLabel')"
        ></modal_input>
        <modal_input
          v-model="contractor.taxID"
          value="taxID"
          type="text"
          :label="$t('addEditModalVue.taxIDLabel')"
        ></modal_input>
        <modal_input
          v-model="contractor.VATRegistrationNumber"
          value="VATRegistrationNumber"
          type="text"
          :label="$t('addEditModalVue.VATRegistrationNumberLabel')"
        ></modal_input>
        <label for="selectRegType">{{$t('addEditModalVue.registerTypeLabel')}}</label>
        <select class="add-edit-inputs" v-model="contractor.registerType" id="selectRegType">
          <option disabled selected value="0">{{$t('addEditModalVue.selectDefault')}}</option>
          <option v-for="regType in regTypes" v-bind:value="regType.value" v-bind:key="regType.value">
            {{ regType.string }}
          </option>
        </select>
        <br/>
        <label for="selectRegDistrict">{{$t('addEditModalVue.registerDistrictLabel')}}</label>
        <select class="add-edit-inputs" v-model="contractor.registerDistrict" id="selectRegDistrict">
          <option disabled selected value="0">{{$t('addEditModalVue.selectDefault')}}</option>
          <option v-for="regDisctrict in regDistricts" v-bind:value="regDisctrict.value" v-bind:key="regDisctrict.value">
            {{ regDisctrict.string }}
          </option>
        </select>
        <modal_input
          v-model="contractor.registerNo"
          value="registerNo"
          type="text"
          :label="$t('addEditModalVue.registerNoLabel')"
        ></modal_input>
        <modal_input
          v-model="contractor.iban"
          value="iban"
          type="text"
          :label="$t('addEditModalVue.ibanLabel')"
        ></modal_input>
        <modal_input
          v-model="contractor.bic"
          value="bic"
          type="text"
          :label="$t('addEditModalVue.bicLabel')"
        ></modal_input>
        <modal_input
          v-model="contractor.invoiceNumber"
          value="invoiceNumber"
          type="text"
          :label="$t('addEditModalVue.invoiceNumberLabel')"
        ></modal_input>
        <label for="checkMultiSportCard">{{$t('addEditModalVue.multisportLabel')}}</label>
        <input class="add-edit-inputs" type="checkbox" v-model="contractor.multisport" :true-value="true" :false-value="false" id="checkMultiSportCard">
        <br/>
        <label for="checkTaxPayer">{{$t('addEditModalVue.taxPayerLabel')}}</label>
        <input class="add-edit-inputs" type="checkbox" v-model="contractor.taxPayer" :true-value="true" :false-value="false" id="checkTaxPayer">
        <br/>
        <label v-if="contractor.taxPayer === true" for="selectTaxRate">{{$t('addEditModalVue.taxRateLabel')}}</label>
        <select class="add-edit-inputs" v-if="contractor.taxPayer === true" v-model="contractor.taxRate" id="selectTaxRate">
          <option disabled selected value="0">{{$t('addEditModalVue.selectDefault')}}</option>
          <option v-for="taxRate in taxRates" v-bind:key="taxRate.value" v-bind:value="taxRate.value">
            {{ taxRate.string }}
          </option>
        </select>
        <modal_input
          v-model="contractor.rate"
          value="rate"
          type="text"
          :label="$t('addEditModalVue.rateLabel')"
        ></modal_input>
        <modal_input
          v-model="contractor.activeIncome"
          value="activeIncome"
          type="text"
          :label="$t('addEditModalVue.activeIncomeLabel')"
        ></modal_input>
        <modal_input
          v-model="contractor.pasiveIncome"
          value="pasiveIncome"
          type="text"
          :label="$t('addEditModalVue.pasiveIncomeLabel')"
        ></modal_input>

        <button v-if="modalAdd" type="submit">{{$t('addEditModalVue.modalAddTitle')}}</button>
        <button v-else @click.prevent="editEmployee">{{$t('addEditModalVue.modalEditTitle')}}</button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import modal_input from "../../components/modal_input";

const Swal = require('sweetalert2');

export default {
  name: "employee_add_form",
  data() {
    return {
      regTypes: [
        {value: 1, string: this.$t('addEditModalVue.registerTypeTrade')},
        {value: 2, string: this.$t('addEditModalVue.registerTypeBusiness')}
      ],

      regDistricts: [
        {value: 1, string: "Bánovce nad Bebravou"},
        {value: 2, string: "Banská Bystrica"},
        {value: 3, string: "Banská Štiavnica"},
        {value: 4, string: "Bardejov"},
        {value: 5, string: "Bratislava I"},
        {value: 6, string: "Bratislava II"},
        {value: 7, string: "Bratislava III"},
        {value: 8, string: "Bratislava IV"},
        {value: 9, string: "Bratislava V"},
        {value: 10, string: "Brezno"},
        {value: 11, string: "Bytča"},
        {value: 12, string: "Čadca"},
        {value: 13, string: "Detva"},
        {value: 14, string: "Dolný Kubín"},
        {value: 15, string: "Dunajská Streda"},
        {value: 16, string: "Galanta"},
        {value: 17, string: "Gelnica"},
        {value: 18, string: "Hlohovec"},
        {value: 19, string: "Humenné"},
        {value: 20, string: "Ilava"},
        {value: 21, string: "Kežmarok"},
        {value: 22, string: "Komárno"},
        {value: 23, string: "Košice I"},
        {value: 24, string: "Košice II"},
        {value: 25, string: "Košice III"},
        {value: 26, string: "Košice IV"},
        {value: 27, string: "Košice-okolie"},
        {value: 28, string: "Krupina"},
        {value: 29, string: "Kysucké Nové Mesto"},
        {value: 30, string: "Levice"},
        {value: 31, string: "Levoča"},
        {value: 32, string: "Liptovský Mikuláš"},
        {value: 33, string: "Lučenec"},
        {value: 34, string: "Malacky"},
        {value: 35, string: "Martin"},
        {value: 36, string: "Medzilaborce"},
        {value: 37, string: "Michalovce"},
        {value: 38, string: "Myjava"},
        {value: 39, string: "Námestovo"},
        {value: 40, string: "Nitra"},
        {value: 41, string: "Nové Mesto nad Váhom"},
        {value: 42, string: "Nové Zámky"},
        {value: 43, string: "Partizánske"},
        {value: 44, string: "Pezinok"},
        {value: 45, string: "Piešťany"},
        {value: 46, string: "Poltár"},
        {value: 47, string: "Poprad"},
        {value: 48, string: "Považská Bystrica"},
        {value: 49, string: "Prešov"},
        {value: 50, string: "Prievidza"},
        {value: 51, string: "Púchov"},
        {value: 52, string: "Revúca"},
        {value: 53, string: "Rimavská Sobota"},
        {value: 54, string: "Rožňava"},
        {value: 55, string: "Ružomberok"},
        {value: 56, string: "Sabinov"},
        {value: 57, string: "Senec"},
        {value: 58, string: "Senica"},
        {value: 59, string: "Skalica"},
        {value: 60, string: "Snina"},
        {value: 61, string: "Sobrance"},
        {value: 62, string: "Spišská Nová Ves"},
        {value: 63, string: "Stará Ľubovňa"},
        {value: 64, string: "Stropkov"},
        {value: 65, string: "Svidník"},
        {value: 66, string: "Šaľa"},
        {value: 67, string: "Topoľčany"},
        {value: 68, string: "Trebišov"},
        {value: 69, string: "Trenčín"},
        {value: 70, string: "Trnava"},
        {value: 71, string: "Turčianske Teplice"},
        {value: 72, string: "Tvrdošín"},
        {value: 73, string: "Veľký Krtíš"},
        {value: 74, string: "Vranov nad Topľou"},
        {value: 75, string: "Zlaté Moravce"},
        {value: 76, string: "Zvolen"},
        {value: 77, string: "Žarnovica"},
        {value: 78, string: "Žiar nad Hronom"},
        {value: 79, string: "Žilina"},
      ],

      taxRates: [
        {value: 1, string: "0%"},
        {value: 2, string: "10%"},
        {value: 3, string: "20%"},
      ],

      showModal: true,
      contractor: {
        companyName: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        street: "",
        postalCode: "",
        city: "",
        country: "",
        businessID: "",
        taxID: "",
        VATRegistrationNumber: "",
        registerType: 0,
        registerDistrict: 0,
        registerNo: "",
        iban: "",
        bic: "",
        invoiceNumber: "FA01-",
        taxPayer: false,
        taxRate: 0,
        active: true,
        multisport: false,
        rate: "0",
        activeIncome: "0",
        pasiveIncome: "0"
      },
    };
  },
  computed: {
    ...mapGetters(["employees", "getRole", "getId"]),
  },
  props: ["modalTitle", "modalAdd", "contractorForEdit", "date"],
  components: {
    modal_input
  },
  methods: {
    closeMyself() {
      this.$emit("finished", true);
    },
    addEmployee() {
      console.log(this.date.value);
      if (this.formValidation() === true) {
        this.$store.dispatch('addContractor', {payload: this.contractor, seasonFrom: this.date.value, seasonTo: this.date.endOfMonth});
        this.closeMyself();
      }
    },
    editEmployee() {
      if (this.formValidation() === true) {
        this.$store.dispatch('updateContractor', {payload: this.contractorForEdit, seasonFrom: this.date.value, seasonTo: this.date.endOfMonth});
        this.closeMyself();
      }
    },
    formValidation() {
      let checkSum = 0;
      if (!this.contractor.firstName) {
        Swal.fire({
          title: this.$t('addEditModalVue.firstNameErrorTitle'),
          text: this.$t('addEditModalVue.firstNameErrorText'),
          icon: 'error',
        confirmButtonText: this.$t('addEditModalVue.errorButton')
        });
        checkSum++;
      }
      if (!this.contractor.lastName) {
        Swal.fire({
          title: this.$t('addEditModalVue.lastNameErrorTitle'),
          text: this.$t('addEditModalVue.lastNameErrorText'),
          icon: 'error',
        confirmButtonText: this.$t('addEditModalVue.errorButton')
        });
        checkSum++;
      }
      if (!this.contractor.companyName) {
        Swal.fire({
          title: this.$t('addEditModalVue.companyNameErrorTitle'),
          text: this.$t('addEditModalVue.companyNameErrorText'),
          icon: 'error',
        confirmButtonText: this.$t('addEditModalVue.errorButton')
        });
        checkSum++;
      }
      if (!this.contractor.email) {
        Swal.fire({
          title: this.$t('addEditModalVue.emailErrorTitle'),
          text: this.$t('addEditModalVue.emailErrorText'),
          icon: 'error',
        confirmButtonText: this.$t('addEditModalVue.errorButton')
        });
        checkSum++;
      }
      if (!this.contractor.phone) {
        Swal.fire({
          title: this.$t('addEditModalVue.phoneErrorTitle'),
          text: this.$t('addEditModalVue.phoneErrorText'),
          icon: 'error',
        confirmButtonText: this.$t('addEditModalVue.errorButton')
        });
        checkSum++;
      }
      if (!this.contractor.street) {
        Swal.fire({
          title: this.$t('addEditModalVue.streetErrorTitle'),
          text: this.$t('addEditModalVue.streetErrorText'),
          icon: 'error',
        confirmButtonText: this.$t('addEditModalVue.errorButton')
        });
        checkSum++;
      }
      if (!this.contractor.postalCode) {
        Swal.fire({
          title: this.$t('addEditModalVue.postalCodeErrorTitle'),
          text: this.$t('addEditModalVue.postalCodeErrorText'),
          icon: 'error',
        confirmButtonText: this.$t('addEditModalVue.errorButton')
        });
        checkSum++;
      }
      if (!this.contractor.city) {
        Swal.fire({
          title: this.$t('addEditModalVue.cityErrorTitle'),
          text: this.$t('addEditModalVue.cityErrorText'),
          icon: 'error',
        confirmButtonText: this.$t('addEditModalVue.errorButton')
        });
        checkSum++;
      }
      if (!this.contractor.country) {
        Swal.fire({
          title: this.$t('addEditModalVue.countryErrorTitle'),
          text: this.$t('addEditModalVue.countryErrorText'),
          icon: 'error',
        confirmButtonText: this.$t('addEditModalVue.errorButton')
        });
        checkSum++;
      }
      // if (!this.contractor.taxID) {
      //   Swal.fire({
      //     title: this.$t('addEditModalVue.taxIDErrorTitle'),
      //     text: this.$t('addEditModalVue.taxIDErrorText'),
      //     icon: 'error',
      //   confirmButtonText: this.$t('addEditModalVue.errorButton')
      //   });
      //   checkSum++;
      // }
      // if (this.contractor.registerType === 0) {
      //   Swal.fire({
      //     title: this.$t('addEditModalVue.registerTypeErrorTitle'),
      //     text: this.$t('addEditModalVue.registerTypeErrorText'),
      //     icon: 'error',
      //   confirmButtonText: this.$t('addEditModalVue.errorButton')
      //   });
      //   checkSum++;
      // }
      // if (this.contractor.registerDistrict === 0) {
      //   Swal.fire({
      //     title: this.$t('addEditModalVue.registerDistrictErrorTitle'),
      //     text: this.$t('addEditModalVue.registerDistrictErrorText'),
      //     icon: 'error',
      //   confirmButtonText: this.$t('addEditModalVue.errorButton')
      //   });
      //   checkSum++;
      // }
      if (!this.contractor.registerNo) {
        Swal.fire({
          title: this.$t('addEditModalVue.registerNoErrorTitle'),
          text: this.$t('addEditModalVue.registerNoErrorText'),
          icon: 'error',
        confirmButtonText: this.$t('addEditModalVue.errorButton')
        });
        checkSum++;
      }
      if (!this.contractor.iban) {
        Swal.fire({
          title: this.$t('addEditModalVue.ibanErrorTitle'),
          text: this.$t('addEditModalVue.ibanErrorText'),
          icon: 'error',
        confirmButtonText: this.$t('addEditModalVue.errorButton')
        });
        checkSum++;
      }
      // if (!this.contractor.bic) {
      //   Swal.fire({
      //     title: this.$t('addEditModalVue.bicErrorTitle'),
      //     text: this.$t('addEditModalVue.bicErrorText'),
      //     icon: 'error',
      //   confirmButtonText: this.$t('addEditModalVue.errorButton')
      //   });
      //   checkSum++;
      // }
      if (!this.contractor.invoiceNumber) {
        Swal.fire({
          title: this.$t('addEditModalVue.invoiceNumberErrorTitle'),
          text: this.$t('addEditModalVue.invoiceNumberErrorText'),
          icon: 'error',
        confirmButtonText: this.$t('addEditModalVue.errorButton')
        });
        checkSum++;
      }
      this.taxPayer = this.taxPayer === "1";
      this.multisport = this.multisport === '1';

      if (checkSum !== 0) {
        return false;
      } else {
        return true;
      }
    }
  },
  mounted() {
    if (this.contractorForEdit) {
      this.contractor = this.contractorForEdit;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/colors.scss";

@media only screen and (max-width: 600px) {
  button {
    width: 60vw !important;
  }
  h1 {
    font-size: 1.7em;
    align-self: center;
  }
}

@media (min-width: 601px) {
  form button {
    width: 100%;
  }
}

.form_container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  text-align: center;

  h1 {
    text-align: left;
    margin-top: 1.1em;
    padding: 0 1em;
    color: $company-primary;
  }

  .wrapper {
    flex: 1;
    overflow-y: scroll;
    margin-bottom: 1.5em;
    padding: 1em 2em;
  }
}

.admCheckBox {
  display: flex;
  align-items: center;
  margin-bottom: 1em;
  margin-left: 1.5em;

  p {
    margin: 0.5em;
  }
}

input[type="radio"] {
  margin: 0;
  margin-left: 0.5em;
  width: 2em;
  transform: scale(1.5);
}

form button {
  border: 0.1em solid $gray;
  border-radius: 15px;
  justify-self: center;
  background-color: $company-accent;
  margin: 0;
  font-weight: bold;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: $company-primary;
  height: 4em;
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    background: $hover-gray;
  }
}

.add-edit-inputs {
  margin: 5px;
}
</style>
